import { AutocompleteWithLabel } from '@adotel/components'
import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'
import { Button } from '@material-ui/core'
import { useState } from 'react'

import { getTranslate } from '../../localization'
import {
  ChannelMonitoring,
  ChannelPushMonitoringFiltersInput,
  HealthStatus,
  StateStatus
} from '../../types/channelPush'
import useStyles from './styles/pushMonitoringFilters.styles'

interface PushMonitoringFiltersProps {
  filters: ChannelPushMonitoringFiltersInput | undefined
  setfilters: React.Dispatch<
    React.SetStateAction<ChannelPushMonitoringFiltersInput>
  >
  data: ChannelMonitoring[]
  getChannelPushMonitoring: LazyQueryExecFunction<
    {
      channelPushMonitoring: ChannelMonitoring[]
    },
    OperationVariables
  >
}

function PushMonitoringFilters({
  filters,
  setfilters,
  data,
  getChannelPushMonitoring
}: PushMonitoringFiltersProps) {
  const classes = useStyles()
  const [autoCompleteValuesForChannels, setAutoCompleteValuesForChannels] =
    useState<any[]>([])
  const [autoCompleteValuesFroStatus, setAutoCompleteValuesFroStatus] =
    useState<any>(null)
  const [autoCompleteValuesForCircuit, setAutoCompleteValuesForCircuit] =
    useState<any>(null)
  const statusMenuItem: { value: HealthStatus; label: string }[] = [
    { value: 'Normal', label: 'Normal' },
    { value: 'Warning', label: 'Warning' },
    { value: 'Critical', label: 'Critical' }
  ]
  const circuitMenuItems: { value: StateStatus; label: string }[] = [
    { value: 'Disconnected', label: 'Disconnected' },
    { value: 'Suspended', label: 'Suspended' },
    { value: 'Connected', label: 'Connected' }
  ]

  const onClickApply = () => {
    getChannelPushMonitoring({ variables: { filters: filters } })
  }

  const resetFilters = () => {
    setAutoCompleteValuesForChannels([])
    setAutoCompleteValuesFroStatus(null)
    setAutoCompleteValuesForCircuit(null)
    setfilters({
      channelsCode: [],
      healthStatus: undefined,
      state: undefined
    })
  }

  return (
    <div className={classes.root}>
      <div className={classes.eachRow}>
        <AutocompleteWithLabel
          value={autoCompleteValuesForChannels}
          showSelectAll
          multiple
          placeholder={getTranslate('Select Channels')}
          limitTags={2}
          fullWidth
          getOptionLabel={(option) => option.label || ''}
          label={getTranslate('Channels')}
          inputSize="small"
          size="small"
          options={data?.map((item: ChannelMonitoring) => ({
            label: item.channelName,
            value: item.channelCode,
            code: item.channelCode,
            id: item.channelId
          }))}
          onChange={(_, v) => {
            if (v.length > 0) {
              const tempSelectedChannels = v.map((item) => ({
                label: item.label,
                value: item.value,
                code: item.code,
                id: item.id
              }))
              setAutoCompleteValuesForChannels(tempSelectedChannels)
              setfilters(() => {
                const temp = tempSelectedChannels.map((ele: any) => ele.value)

                return {
                  ...filters,
                  channelsCode: temp
                }
              })
            } else {
              setAutoCompleteValuesForChannels([])
              setfilters({
                ...filters,
                channelsCode: undefined
              })
            }
          }}
          loadingText={getTranslate('Loading') + '...'}
        />
        <AutocompleteWithLabel
          label={getTranslate('Health Status')}
          inputSize="small"
          placeholder={getTranslate('Select Status')}
          value={autoCompleteValuesFroStatus}
          onChange={(_, v: any) => {
            if (v) {
              setAutoCompleteValuesFroStatus({
                value: v.value,
                label: v.label
              })
              setfilters({
                ...filters,
                healthStatus: v.value
              })
            } else {
              setAutoCompleteValuesFroStatus(null)
              setfilters({
                ...filters,
                healthStatus: undefined
              })
            }
          }}
          options={statusMenuItem.map((item) => ({
            value: item.value,
            label: getTranslate(item.label)
          }))}
          getOptionLabel={(option) => option.label || ''}
          getOptionSelected={(option, value) => option.value === value.value}
        />
        <AutocompleteWithLabel
          label={getTranslate('State')}
          inputSize="small"
          placeholder={getTranslate('Select State')}
          value={autoCompleteValuesForCircuit}
          onChange={(_, v: any) => {
            if (v) {
              setAutoCompleteValuesForCircuit({
                value: v.value,
                label: v.label
              })
              setfilters({
                ...filters,
                state: v.value
              })
            } else {
              setAutoCompleteValuesForCircuit(null)
              setfilters({
                ...filters,
                state: undefined
              })
            }
          }}
          options={circuitMenuItems.map((item) => ({
            value: item.value,
            label: getTranslate(item.label)
          }))}
          getOptionLabel={(option) => option.label || ''}
          getOptionSelected={(option, value) => option.value === value.value}
        />
      </div>
      <div className={classes.buttonContainer}>
        <Button
          variant="text"
          className={classes.resetButton}
          onClick={resetFilters}>
          {getTranslate('Reset')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickApply}
          disabled={false}>
          {getTranslate('Apply')}
        </Button>
      </div>
    </div>
  )
}

export default PushMonitoringFilters
